import { Analytics } from '@vercel/analytics/next'
import { SpeedInsights } from '@vercel/speed-insights/react'

export const VercelAnalytics = () => {
  const isVercelDeployment = process.env.VERCEL_ENV === 'production'

  if (!isVercelDeployment) {
    return null
  }

  return (
    <>
      <Analytics />
      <SpeedInsights />
    </>
  )
}
